module.exports = __webpack_public_path__ + "img/機械雲平台使用流程.4d37820c.png";